module.exports = "<div style=\"position: absolute; left:50%; top:50%;font-size: 20px;\">loading...</div>"